import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30 seconds
      retry: (failureCount, error) => {
        // Don't retry on 401/403/402 (auth/permission/payment errors)
        if (
          error instanceof ApiError &&
          (error.statusCode === 401 || error.statusCode === 402 || error.statusCode === 403)
        ) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});

// Custom API error class
export class ApiError extends Error {
  constructor(
    public readonly statusCode: number,
    public readonly error: string,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
